(function () {
  var rootClass = 'r4m_cookie_consent';
  var cookieName = '_cca';
  var zIndex_liveChatButton = '10000';

  var privacyUrl = window._privacy_statement_url || '/terms-of-service';

  // lang
  const lang = window._cookie_consent_lang || document.documentElement.lang || 'en';

  const allMessages = {
    en: {
      by_using: 'This website [uses cookies] to ensure you get the best experience.',
      close: 'Close',
    },
    fr: {
      by_using: 'Ce site web utilise [des cookies] pour vous garantir une expérience optimale.',
      close: 'Fermer',
    },
    es: {
      by_using: 'Este sitio web utiliza [cookies] para que usted tenga la mejor experiencia.',
      close: 'Cerca',
    },
    vi: {
      by_using: 'Trang web này [sử dụng cookie] để đảm bảo bạn có được trải nghiệm tốt nhất.',
      close: 'Đóng',
    },
  };

  const messages = allMessages[lang] || allMessages.en;

  if (!messages) console.warn('Messages not found');

  // css
  const head = document.head || document.getElementsByTagName('head')[0];

  const css = `
    <style type="text/css">
      .${rootClass} {
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        font-size: 14px;
        line-height: 19px;
        position: fixed;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: ${zIndex_liveChatButton};
        padding: 9px;
        background: white;
        color: rgba(0, 0, 0, 0.7);
        border-width: 1px 0px 0px;
        border-style: solid inset inset;
        border-top-color: rgba(0, 0, 0, 0.15);
        border-right-color: initial;
        border-bottom-color: initial;
        border-left-color: initial;
        border-image: initial;
      }
  
      .${rootClass} .consent_contents {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
  
      .${rootClass} .consent_contents.consent_contents a {
        color: rgb(66, 133, 244);
      }
  
      .${rootClass} .consent_text {
        align-self: center;
        max-width: 800px;
      }
  
      .${rootClass} .consent_btn {
        padding: 8px 12px;
        cursor: pointer;
        display: inline-block;
        border-radius: 70px;
        text-transform: uppercase;
      }
  
      .${rootClass} .accept_container {
        padding-left: 16px;
      }
  
      .${rootClass} .accept_btn {
        background: rgba(0, 0, 0, 0.06);
        color: rgba(0, 0, 0, 0.87);
        font-weight: 600;
      }
      
      @media (max-width: 800px) {
        .${rootClass} {
          font-size: 12px;
          padding: 26px;
          line-height: 16px;
          z-index: ${zIndex_liveChatButton};
        } 
      }
    </style>
  `;

  head.insertAdjacentHTML('beforeend', css);

  // elems
  function htmlLink (url, t) {
    return `<a href="${url}" target="_blank">${t}</a>`;
  }

  function makeElement(rootClass) {
    var body = document.body;
    var e = document.createElement('DIV');
    if (rootClass) e.classList.add(rootClass);

    var text = messages.by_using.replaceAll(/\[(.*?)]/g, (m, p1) => htmlLink(privacyUrl, p1));

    e.innerHTML = [
      // '<p class="consent_title">This website uses cookies</p>',
      '<div class="consent_contents">',
      '<div class="consent_text">',
      text,
      '</div>',
      '<div class="accept_container"><div class="consent_btn accept_btn">',
      messages.close,
      '</div></div>',
      '</div>',
    ].join('');
    body.append(e);

    return e;
  }

  function shiftBodyContent(shiftHeight) {
    document.body.style.paddingBottom = shiftHeight + 'px';
  }

  // cookies
  var cookieService = { // borrowed from the js-core project
    setCookie: function (name, value, days) {
      var domain = cookieService.getCookie('cookie_domain') || '';
      if (domain !== '') {
        domain = '; domain=' + domain;
      }
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }

      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + domain;
    },
    getCookie: function (name) {
      var nameEQ = name + "=",
        ca = document.cookie.split(';'),
        ca_size = ca.length;

      for (var i = 0; i < ca_size; i++) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
      }

      return null;
    }
  };

  function alreadyAccepted() {
    return !!cookieService.getCookie(cookieName);
  }

  if (alreadyAccepted()) {
    return;
  }

  var e = makeElement(rootClass);
  var acceptBtn = e.querySelector('.accept_btn');
  acceptBtn.addEventListener('click', function () {
    cookieService.setCookie(
      cookieName,
      1,
      365 * 10 // expires in 10 years
    );
    e.remove();
    shiftBodyContent(0);
  });

  shiftBodyContent(e.offsetHeight || e.clientHeight || e.scrollHeight);

  var resizeTimeout;
  window.onresize = function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      shiftBodyContent(e.offsetHeight || e.clientHeight || e.scrollHeight);
    }, 250);
  };
})();
